import React, { useState, useCallback } from "react";
import Login from "../components/user/Login";
import Slider from "../components/utilities/Slider";
import MobileDetection from "../components/utilities/MobileDetection";

function Lockscreen() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const toggleMenu = useCallback(() => {
    setIsMenuOpen((prev) => !prev);
  }, []);

  const handleMobileDetection = useCallback((mobile) => {
    setIsMobile(mobile);
  }, []);

  if (isMobile) {
    return (
      <div className="bg-black w-full h-screen text-center text-3xl px-7 overflow-hidden flex flex-col justify-center items-center">
        <br />
        We regret to inform you that this version is currently unavailable for mobile devices.
      </div>
    );
  }

  return (
    <>
      {!isMobile && <MobileDetection onDetectMobile={handleMobileDetection} />}

      <div
  className="absolute bg-black h-screen w-full"
  style={{
    background:
      "url(https://assets.itshivam.me/background-image/mac.jpg) no-repeat center center",
    backgroundSize: "cover", 
    backgroundRepeat: "no-repeat", 
    backgroundPosition: "center", 
    width: "100vw",
    height: "100vh", 
  }}
></div>


      <div className="absolute left-0 top-0 h-screen w-full flex flex-col items-center z-10">
        <Login />
      </div>

      <Slider
        isMenuOpen={isMenuOpen}
        setIsMenuOpen={setIsMenuOpen}
        toggleMenu={toggleMenu}
      />
    </>
  );
}

export default Lockscreen;
